export default __webpack_public_path__ + "static/media/logo.b0dfd26a.svg";